/// FOURJS_START_COPYRIGHT(D,2019)
/// Property of Four Js*
/// (c) Copyright Four Js 2019, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum(
  "ClipboardPasteCommand",
  ["CommandBase"],
  /**
   * @param {gbc} context
   * @param {classes} cls
   */
  function (context, cls) {
    /**
     * Native back command.
     * @class ClipboardPasteCommand
     * @memberOf classes
     * @extends classes.CommandBase
     */
    cls.ClipboardPasteCommand = context.oo.Class(cls.CommandBase, function ($super) {
      return /** @lends classes.ClipboardPasteCommand.prototype */ {
        __name: "ClipboardPasteCommand",

        /** @type String */
        _textValue: null,

        /** @type classes.WidgetBase */
        _widget: null,

        /** @type {?number} */
        _insertPosition: null,

        /**
         * @param {classes.VMApplication} app owner
         * @param {String} textValue text to be pasted
         * @param {classes.WidgetBase} widget
         * @param {?number} insertPosition - explicit insert position
         */
        constructor: function (app, textValue, widget = null, insertPosition = null) {
          $super.constructor.call(this, app, null);
          this._textValue = textValue;
          this._widget = widget;
          this._insertPosition = insertPosition;
        },

        /**
         * @inheritDoc
         */
        execute: function () {
          if (!this._textValue) {
            return false;
          }

          let copyingRemainingText = false;

          if (!this._widget) {
            // It means that we are pasting remaining text from a previous paste command
            copyingRemainingText = true;

            // use focused widget,
            const currentFocusedNode = this._app.getFocusedVMNodeAndValue(true);
            this._widget = currentFocusedNode.getWidget();
          }

          // if no widget or widget has not the focus --> no paste
          if (!this._widget || !this._app.hasVMFocus(this._widget)) {
            return false;
          }

          let textToPaste = this._textValue;
          let remainingTextToPaste = null;

          // Manage copy in multiple input array cells
          if (this._widget.getDialogType() === "InputArray") {
            const regexpArray = [];

            let acceptReturns = false;
            let acceptTabs = false;

            if (this._widget.isInstanceOf(cls.TextEditWidget)) {
              const textEditWidget = /** @type cls.TextEditWidget */ this._widget;
              acceptReturns = textEditWidget.getWantReturns();
              acceptTabs = textEditWidget.getWantTabs();
            }

            if (!acceptReturns || copyingRemainingText) {
              regexpArray.push(String.raw`\r\n`, String.raw`\r`, String.raw`\n`);
            }
            if (!acceptTabs || copyingRemainingText) {
              regexpArray.push(String.raw`\t`);
            }

            if (regexpArray.length > 0) {
              const regexp = new RegExp(regexpArray.join("|"));
              const values = this._textValue.split(regexp, 1);
              if (values.length >= 1) {
                textToPaste = values[0];
                remainingTextToPaste = this._textValue.slice(values[0].length);

                // remove the separator char at start
                const regexpStart = new RegExp("^(" + regexpArray.join("|") + ")");
                remainingTextToPaste = remainingTextToPaste.replace(regexpStart, "");
              }
            }
          }

          if (this._insertPosition !== null && this._widget.hasCursors()) {
            this._widget.setCursorPosition(this._insertPosition);
          }

          // Paste text in the widget
          if (this._widget.manageBeforeInput(textToPaste)) {
            this._widget.manageClipboardPaste(textToPaste);
            this._widget.manageInput(textToPaste);
          }

          // if there is still text to paste, paste it in the next field
          if (remainingTextToPaste) {
            this._app.action.executeLocalAction("nextfield");

            // Add new command only when all scheduled command are finished
            this._app.scheduler.schedulerProcessEndedEvent(() => {
              // if there is an ERROR message stop the recursive paste
              if (!this._app.message.hasErrorMessage()) {
                this._app.scheduler.clipboardPasteCommand(remainingTextToPaste);
              }
            }, true);
          }

          return true;
        }
      };
    });
  }
);
